module.exports = __webpack_public_path__ + "img/img6.f84f3af2.svg";